import {
  StoreServicesGetterParams,
  StoreServicesGetterPriceNetParams,
  ServicesState,
} from './types';

export default {
  activeService(state: ServicesState, getters: any) {
    return (params: any) => {
      const selectedServices = getters.selectedServices(params);
      if (selectedServices) {
        return selectedServices[params.elementIndex];
      }
      return null;
    };
  },
  isServiceRequired(state: ServicesState, getters: any) {
    return (params: any) => {
      const selectedServices = getters.selectedServices(params);
      const serviceDefinitions = getters.serviceDefinitions(params.jobId);
      if (selectedServices && serviceDefinitions) {
        const { service: selectedService } =
          selectedServices[params.elementIndex];
        for (const { service } of selectedServices) {
          const serviceDefinition = serviceDefinitions[service];
          if (
            serviceDefinition?.only_in_combination_with?.some(
              (i) => i.service == selectedService,
            )
          ) {
            return true;
          }
        }
      }
      return false;
    };
  },
  getServiceIndex(state: ServicesState) {
    return (params: StoreServicesGetterParams) => {
      return state.selected[params.jobId].findIndex((service: any) => {
        return (
          service.service === params.service &&
          (params.productId === undefined
            ? true
            : service.productId === params.productId)
        );
      });
    };
  },
  selectedServices(state: ServicesState) {
    return (params: StoreServicesGetterParams) => {
      if (state.selected[params.jobId]) {
        const selectedServices = state.selected[params.jobId];
        if (params.productId === undefined || params.productId === null) {
          return selectedServices;
        }
        return selectedServices.filter(
          (service: any) => service.productId === params.productId,
        );
      }
      return [];
    };
  },
  allSelectedServices(state: ServicesState, getters: any) {
    return (jobId: string) => {
      return getters.selectedServices({
        jobId,
      });
    };
  },
  serviceDefinition(state: ServicesState) {
    return (opportunitySfid: string, serviceSfid: string) => {
      if (state.definitions[opportunitySfid]) {
        return state.definitions[opportunitySfid][serviceSfid];
      }
    };
  },
  serviceDefinitions(state: ServicesState, getters: any) {
    return (jobId: string) => {
      const opportunitySfid = getters.jobOpportunity(jobId).sfid;
      return state.definitions[opportunitySfid];
    };
  },
  duplicateServicesAllowed(state: ServicesState, getters: any) {
    return (jobId: string) => {
      const opportunitySfid = getters.jobOpportunity(jobId).sfid;
      return opportunitySfid === '0061p00000mv76wAAA';
    };
  },
  servicesGroup(state: ServicesState, getters: any) {
    return (params: StoreServicesGetterParams) => {
      const opportunitySfid = getters.jobOpportunity(params.jobId).sfid;

      if (params.serviceSfid) {
        const serviceDefinition = getters.serviceDefinition(
          opportunitySfid,
          params.serviceSfid,
        );

        if (serviceDefinition) {
          const groupName = serviceDefinition.group_name[getters.locale];

          if (groupName) {
            const serviceDefinitions = state.definitions[opportunitySfid];
            return Object.keys(serviceDefinitions)
              .reduce((acc: any[], serviceSfid: string): any[] => {
                if (
                  serviceDefinitions[serviceSfid].group_name[getters.locale] ==
                  groupName
                ) {
                  return [...acc, serviceDefinitions[serviceSfid]];
                }
                return acc;
              }, [])
              .sort(
                (a: any, b: any) => a.minimum_quantity - b.minimum_quantity,
              );
          }
        }
      }
      return null;
    };
  },

  servicesPriceNet(state: ServicesState, getters: any) {
    return (params: StoreServicesGetterPriceNetParams) => {
      if (state.selected[params.jobId]) {
        const opportunitySfid = getters.jobOpportunity(params.jobId)?.sfid;
        if (state.definitions[opportunitySfid]) {
          const services = state.selected[params.jobId];
          const result = services.reduce(
            (accServices: number, service: any) => {
              const serviceDef =
                state.definitions[opportunitySfid][service.service];
              let price = 0;
              if (params.targetField in service) {
                price = service[params.targetField];
              } else if (serviceDef) {
                price = serviceDef[params.targetField];
              }
              return service.service
                ? accServices + service.quantity * price
                : accServices;
            },
            0,
          );
          return result;
        }
      }
      return 0;
    };
  },
  customServicesErrors(state: ServicesState) {
    return state.customServicesErrors;
  },
};
